import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import axios from "axios";
import ShiftPatternService from "@/services/ShiftPatternService";

export default {
  name: "shiftPatternDetail",
  components: {
    MainLayout,
    Loading
  },

  data() {
    return {
      noDataMsg: CONFIG.NO_DATA_FOUND,
      days: CONFIG.DAYS,
      patternDetail: [],
      selectedDays: {},
      selectedShiftsByDay: {},
      isLoading: false,
      patternName: ""
    };
  },

  methods: {
    fetchPatternDetail() {
      this.isLoading = true;
      axios.get('/shift-pattern/' + this.$route.params.id + '/info')
      .then((response) => {
        this.patternDetail = response.data.patternInfo;
        if (this.patternDetail.length) {
          this.patternName = this.patternDetail[0].pattern_name;
          ShiftPatternService.defineCheckForDayAndShifts(this.patternDetail, this.selectedDays, this.selectedShiftsByDay, this.$set)
        }
      })
      .catch((err) => {
        if (err.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        } if (err.response.status == 500) {
          console.log('500 error')
        }
        this.isLoading = false;
        console.log(err)
      })
      .finally(() => {
        this.isLoading = false;
      })
    },

    changeTimeFormat(time) {
      return ShiftPatternService.changeTimeFormat(time);
    },

    showList() {
      this.$router.push({
        name : "shiftPatternList"
      });
    }
  },

  mounted() {
    this.isLoading = true;
    this.fetchPatternDetail();
  },
};
